module.exports = __webpack_public_path__ + "img/crypto4.36f9c2a4.png";